import { Branch } from "./Branch";
import { LinkedFirestoreDocument } from "@/core/modules/firestore/objects/LinkedFirestoreDocument";

import { DateField, StringField } from "@/core/fields";

export class ActiveLinkedBranch extends LinkedFirestoreDocument {
  public name: string | undefined = undefined;
  public to: Date | undefined = undefined;

  public constructor(firestoreData?: Record<string, unknown>) {
    super();
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public static createFromBranch(branch: Branch): ActiveLinkedBranch {
    const activeLinkedBranch: ActiveLinkedBranch = new ActiveLinkedBranch();
    activeLinkedBranch.id = branch.id;
    activeLinkedBranch.name = branch.name;

    return activeLinkedBranch;
  }

  public fromFirestore(data: Record<string, unknown>): ActiveLinkedBranch {
    super.fromFirestore(data);

    this.name = StringField.fromFirestore(data.name);
    this.to = DateField.fromFirestore(data.to);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);
    firestoreData.to = DateField.toFirestore(this.to);

    return firestoreData;
  }
}
